"use client"

import type { SupportedLocales } from "#environment/i18nConfig"
import type { Artwork } from "#models/artwork"

import { useTranslation } from "#modules/localization/translations.client"
import { OImage } from "#modules/optimization/media/image"
import { Link } from "#utils/localization/clientUtils"

export default function ArtworkPreview({ artwork, lazy, locale }: { artwork: Artwork; lazy?: boolean; locale: SupportedLocales }) {
  const { t } = useTranslation("page/artwork")

  return (
    //@ts-ignore TODO remove ignore
    <Link locale={locale} href={`/artworks/${artwork.slug}`} localizedSlugs={artwork.localizedSlugs} className={"inline-block flex-col text-black"}>
      <div>
        {/*@ts-ignore*/}
        <OImage
          lazy={lazy}
          className={"!static !h-36 !w-auto shadow-[0px_1.0909091234207153px_14.727272033691406px_0px_rgba(0,0,0,0.3)]"}
          media={artwork.previewImages[0]}
          placeholder={"blur"}
          sizes="33vw"
          fill
        />
      </div>

      <div className={"inline-block flex w-[100%] flex-row justify-between pt-2"}>
        <div className={"flex w-[120px] flex-col pr-2"}>
          <div className={"whitespace-normal text-xs font-bold"}>{artwork.name}</div>
          <div className={"pt-1 text-[12px]"}>{artwork.artist!.fullName}</div>
          <div className={"pt-1 text-[10px]"}>{artwork.technique}</div>
          <div className={"text-[10px]"}>
            {artwork.width}x{artwork.height}cm
          </div>
          <div className={"flex items-center pt-1 text-[10px] font-bold"}>
            {!artwork.sold ? (
              `${artwork.price}€`
            ) : (
              <>
                <span className={"mr-2 size-1.5 rounded-full bg-red-600"} />
                {t("buySection.purchaseButton_sold")}
              </>
            )}
          </div>
        </div>
        <div className={"text-[10px]"}>{artwork.year}</div>
      </div>
    </Link>
  )
}
